import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'

export const AddToCrateChart: React.FunctionComponent = ({ }) => {
    const [groupBy, setGroupBy] = React.useState<string>('name')
    const toolbarItems = GroupByType([
        { val: 'name', display: 'Playlist' },
        { val: 'category_name', display: 'Category' },
        { val: 'curator', display: 'Curator' }], groupBy, (selected) => {
            setGroupBy(selected!)
        }, false)
    return (
        <BPMChart title='Added To Crate' subTitle={'Number of Tracks by ' + + (groupBy == 'name' ? 'Playlist' : groupBy == 'curator' ? 'Curator' : 'Category')} type='bar'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>(`playlist/addTocrate`, options, signal)
            }} additionalParams={{ groupBy: groupBy }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            visualRangeEnd={10}
            series={{
                name: groupBy == 'name' ? 'Playlist' : groupBy == 'curator' ? 'Curator' : 'Category', valueField: 'count', argumentField: groupBy,
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Playlist/charts/AddToCrateChart.tsx